import request from "@/utils/request";

// 获取课程
export function getCategory(params) {
  return request({
    url: "/api/allcourses",
    method: "get",
    params,
    isAuth: true,
  });
}

// 获取我的已购课程
export function getMyCourses(params) {
  return request({
    url: "/api/myCourse",
    method: "get",
    params,
    isAuth: true,
  });
}

//获取所有的主题
export function getMyCategory(params) {
  return request({
    url: "/api/myCategory",
    method: "get",
    params: {
      ...params,
      _t: Date.now(), // 防止浏览器缓存旧的 401 响应
    },
    isAuth: true,
  });
}
// 获取课程详情

export function getCoursesDetail(params) {
  return request({
    url: "/api/courseInfo",
    method: "post",
    data: params,
  });
}

// 获取学时榜

export function getHourBd() {
  return request({
    url: "/api/userHourBd",
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: {
      limit: 10,
    },
  });
}
